const AccessDenied: React.FC = () => <div>Access denied</div>

export default AccessDenied
